export enum PriorityMark {
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
}
export enum QCStatus {
  PENDING = "PENDING",
  PASSED = "PASSED",
  REJECT = "REJECT",
  PARTIAL_REJECT = "PARTIAL_REJECT",
  PROCESSING = "PROCESSING_QC",
}

export enum PartNumberHistoryAction {
  IMPORT = "IMPORT",
  EXPORT = "EXPORT",
  EXPORT_ROTATION = "EXPORT_ROTATION",
  NG_MARKED = "NG_MARKED",
  QC_PASS = "QC_PASS",
  QC_FAIL = "QC_FAIL",
  RESTOCK = "RESTROCK",
  STOCK_ADJUSTMENT = "STOCK_ADJUSTMENT",
}
export enum TimesheetStatus {
  TODO = "TODO",
  IN_PROGRESS = "IN_PROGRESS",
  DONE = "DONE",
}
export enum ResearchPurchaseRequestStatus {
  PENDING = "PENDING",
  PURCHASING = "PURCHASING",
  PURCHASED = "PURCHASED",
  REJECT = "REJECT",
}
export enum PurchaseTaskType {
  RD_REQUEST = "RD_REQUEST",
  SALE_ORDER = "SALE_ORDER",
  DIRECTOR = "DIRECTOR",
  PRD_REQUEST = "PRD_REQUEST",
}
export enum PurchaseRequestStatus {
  DRAFT = "DRAFT",
  SUBMITTED = "SUBMITTED",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  CLOSED = "CLOSED",
}
export enum AwbStatus {
  CREATED = "CREATED",
  PICKED_UP = "PICKED_UP",
  IN_TRANSIT = "IN_TRANSIT",
  ARRIVED_AT_HUB = "ARRIVED_AT_HUB",
  OUT_FOR_DELIVERY = "OUT_FOR_DELIVERY",
  DELIVERED = "DELIVERED",
  FAILED = "FAILED",
  RETURNED = "RETURNED",
}
export enum ProjectStatus {
  NEW = "NEW",
  IN_PROGRESS = "IN_PROGRESS",
  DONE = "DONE",
  CANCELLED = "CANCELLED",
}
export enum PurchaseReceiptStatus {
  DRAFT = "DRAFT",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
}
export enum DocumentType {
  DESIGN = "design",
  SPECIFICATION = "specification",
  BOM = "bom",
  TEST_REPORT = "test_report",
  DOCUMENTATION = "documentation",
  OTHER = "other",
}
export enum ProjectPhaseStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  DELAYED = "DELAYED",
}
export enum Currency {
  VND = "VND",
  USD = "USD",
  EUR = "EUR",
  CNY = "CNY",
}
export enum SupplierType {
  LOCAL = "LOCAL",
  ONLINE = "ONLINE",
}
export enum QCStatusProcess {
  PENDING = "PENDING",
  WAITING = "WAITING",
  CHECKING = "CHECKING",
  COMPLETED = "COMPLETED",
}

export enum AttendanceStatus {
  ON_TIME = "ON_TIME",
  LATE = "LATE",
  EARLY = "EARLY",
  ABSENT = "ABSENT",
}

export enum OvertimeStatus {
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  REJECT = "REJECT",
  CANCELLED = "CANCELLED",
}

export enum Status {
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED",
}

export enum LeaveType {
  PLAN = "PLAN",
  SUDDENTY = "SUDDENTY",
  EARLY = "EARLY",
}

export enum StationeryStatus {
  OPEN = "OPEN",
  CLOSED = "CLOSED",
  UPCOMING = "UPCOMING",
}
export enum StationeryItemStatus {
  IS_BUYED = "IS_BUYED",
  IS_NOT_BUYED = "IS_NOT_BUYED",
  IS_NOT_BUY_YET = "IS_NOT_BUY_YET",
  IS_BUYING = "IS_BUYING",
  IS_RETURNED = "IS_RETURNED",
}

export enum Gender {
  MALE = "MALE",
  FEMALE = "FEMALE",
  OTHER = "OTHER",
}
export enum Approver {
  GIAM_DOC = "GIAM_DOC",
  QUAN_LY = "QUAN_LY",
  HR = "HR",
}
export enum ScheduleMeetingType {
  INTERNAL = "INTERNAL",
  EXTERNAL = "EXTERNAL",
  ONLINE = "ONLINE",
}

export enum StepStatus {
  MANAGER_PENDING = "MANAGER_PENDING",
  HR_PENDING = "HR_PENDING",
  DIRECTOR_PENDING = "DIRECTOR_PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}
export enum Reviewer {
  HR = "hr",
  DIRECTION = "director",
  MANAGER = "manager",
}
